document.querySelectorAll('[data-pawable-ingredient-trigger]').forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    var dialog = document.getElementById(trigger.getAttribute('data-pawable-ingredient-trigger'));
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
  });
});

document.querySelectorAll('.pawable-ingredients__modal').forEach(function (dialog) {
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });
  var closeButton = dialog.querySelector('[data-pawable-ingredient-close]');
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      dialog.close();
    });
  }
});
